// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IXXZ32loSJhL\\+oV48M9t5Q\\=\\={margin-bottom:1.5rem;width:100%}._1Vi\\+VyR76f72-UyZq1sWHQ\\=\\={margin-top:1.5rem}", "",{"version":3,"sources":["webpack://./src/components/ExtendWarrantyPlaceholder/ExtendWarrantyPlaceholder.module.scss"],"names":[],"mappings":"AAGA,6BACE,oBAAA,CACA,UAAA,CAEF,8BACE,iBAAA","sourcesContent":["\n                @import '~@purple/style-library/sass/base/base';\n              \n.offer {\n  margin-bottom: 1.5rem;\n  width: 100%;\n}\n.bedframe-aov-margin {\n  margin-top: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"offer": "IXXZ32loSJhL+oV48M9t5Q==",
	"bedframe-aov-margin": "_1Vi+VyR76f72-UyZq1sWHQ=="
};
export default ___CSS_LOADER_EXPORT___;
